// extracted by mini-css-extract-plugin
export default {"ListProduct":"ListProduct_ListProduct__PDWQ+","item":"ListProduct_item__tSzoC","content":"ListProduct_content__SNt9y","price":"ListProduct_price__4epxD"};